module.exports = __webpack_public_path__ + "static/media/galerija_2013 (14).e15957ca.jpg";